import { useEffect } from 'react';
import { KeyboardShortcut, KeyboardShortcutData } from '../../../capacitor_plugins/keyboardShortcuts';
import { editorStyleChange } from '../../components/editor/store/editorActions';
import { STYLE_COMMANDS } from '../../components/editor/richText/richTextConstants';

enum KeyboardShortcutAction {
    BOLD = 'bold',
    ITALIC = 'italic',
    UNDERLINE = 'underline',
}

const addListenerForShortcutAction = async (dispatch: Function) => {
    await KeyboardShortcut.addListener('keyboardShortcut', (data: KeyboardShortcutData) => {
        switch (data.shortcut) {
            case KeyboardShortcutAction.BOLD:
                dispatch(editorStyleChange({ styleCommand: STYLE_COMMANDS.BOLD, selection: undefined }));
                return;
            case KeyboardShortcutAction.ITALIC:
                dispatch(editorStyleChange({ styleCommand: STYLE_COMMANDS.ITALIC, selection: undefined }));
                return;
            case KeyboardShortcutAction.UNDERLINE:
                dispatch(editorStyleChange({ styleCommand: STYLE_COMMANDS.UNDERLINE, selection: undefined }));
                return;
        }
    });
};

export default function (dispatch: Function) {
    useEffect(() => {
        addListenerForShortcutAction(dispatch);
    }, []);
}
